import styled from "styled-components";
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledModalComponent = styled.div`
	display: flex;
	width: 90%;
	height: calc(100vh - 2rem);
	position: relative;
	max-width: 1620px;

	@media (max-width: ${breakpoints.desktop - 1}px) {
		flex-direction: column;
		width: 100vw;
		overflow-y: auto;
		overflow-x: hidden;
		height: 100dvh;
	}
`;

// #####################################################
